/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  user.ts
 * @Package :
 * @author:青瞳科技
 * @date:   2022/1/19 11:27
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 青瞳科技
 * 注意：本内容仅限于深圳青瞳科技有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

import {getUserInfoFromApp, LoginReturnDataDto} from "@/utils/h5ToApp";
import {  checkIsEmpty } from '@/utils/util'
const user = {
    state: {
        token: "",
        mobile: "",
        userId: "",
        password: "",
        roles: [],
        info: {
          userId: "", // 用户id
          companyId: '', // 公司id
          companyName: '', // 公司名称
          logoUrl:'', // 公司头像
          isCusMerchantLoan: false, // 判断公司是否为核心企业
          haveAuditPermission: false, // 判断是否产业合作
          currentVersionCode: '', // 当前版本
          versionCode: '', // 合作方邀请码
          isIdentification: '', // 企业是否实名
          isExpiration: '', // 是否过期
          expirationTime: '', // 到期时间
          trial: '', // 距离到期天数
          partnerCompanyId: '', // 合作方Id
          userOtherType: '', // 用户类型（0普通，1.超级管理员，2.股东）
          partnerCompanyName:'', // 合作方公司名称
          partnerLogoUrl:'', // 合作方公司Logo
        },
        whiteStrips: '',
        ccxStore: {},
        sftpUrl: '',
        firstUserId: "", // 一级用户id
    },

    mutations: {
        SET_TOKEN: (state: any, token: any) => {
            state.token = token;
        },
        SET_MOBILE: (state: any, mobile: string) => {
            state.mobile = mobile;
        },
        SET_USERID: (state: any, userId: any) => {
            state.userId = userId;
        },
        SET_PASSWORD: (state: any, password: any) => {
            state.password = password;
        },
        SET_ROLES: (state: any, roles: any) => {
            state.roles = roles;
        },
        SET_INFO: (state: any, info: any) => {
            state.info = info;
        },
        SET_COMPANY_ID: (state: any, companyId: string) => {
            state.info.companyId = companyId;
        },
        SET_COMPANY_Name: (state: any, companyName: string) => {
            state.info.companyName = companyName;
        },
        SET_IS_CUS_MERCHANT_LOAN: (state: any, isCusMerchantLoan: boolean) => {
          state.isCusMerchantLoan = isCusMerchantLoan
        },
        SET_HAVE_AUDIT_PERMISSION: (state: any, haveAuditPermission: boolean) => {
          state.haveAuditPermission = haveAuditPermission
        },
        SET_CURRENTVERSION: (state: any, info: any) => {
          state.info.currentVersionCode = info.currentVersionCode
          state.info.partnerCompanyId = info.partnerCompanyId
          state.info.partnerCompanyName = info.partnerCompanyName
          state.info.partnerLogoUrl = info.partnerLogoUrl
        },
        SET_WHITE_STRIPS: (state: any, whiteStrips: number) => {
          state.whiteStrips = whiteStrips;
        },
        SET_CCX_STORE: (state: any, ccxStore: string) => {
          state.ccxStore = ccxStore;
        },
        SET_SFTP_URL: (state: any, sftpUrl: string) => {
          state.sftpUrl = sftpUrl;
        },
        SET_FIRST_USER_ID: (state: any, firstUserId: string) => {
          state.firstUserId = firstUserId;
        }
    },

    actions: {
        GetInfo({commit}: any, res: LoginReturnDataDto) {
            return new Promise<void>((resolve, reject) => {
                // getUserInfoFromApp().then((res: LoginReturnDataDto) => {
                    console.log(res)
                    // const menu = res.menus || []
                    commit("SET_TOKEN", res?.access_token);
                    commit("SET_MOBILE", res?.mobile);
                    commit("SET_USERID", res?.userId);

                    if(res && checkIsEmpty(res?.currentVersionCode)){
                      res.currentVersionCode='system'
                    }
                    // if(!checkIsEmpty(res.versionCode)){
                    //   res.currentVersion = res.versionCode
                    // }
                    //
                    // if(checkIsEmpty(res.currentVersion)){
                    //   res.currentVersion='system'
                    // }
                    commit("SET_INFO", res);

                    // const menus = menu.find(
                    //     (i) => i.actionName === "projectmanage"
                    // );
                    // commit("SET_ROLES", [menus]);
                    resolve()
                // })

            })
        },
        setCompanyId({ commit }: any, companyId: string) {
            commit("SET_COMPANY_ID", companyId);
        },
        setCompanyName({ commit }: any, companyName: string) {
            commit("SET_COMPANY_Name", companyName);
        },
        setUserId({ commit }: any, userId: string) {
          commit("SET_USERID", userId);
        },
        setWhiteStrips({ commit }: any, whiteStrips: number) {
            commit("SET_WHITE_STRIPS", whiteStrips)
        },
        setFirstUserId({ commit }: any, firstUserId: string) {
          commit("SET_FIRST_USER_ID", firstUserId);
        }
    }
};

export default user;
